import styled from 'styled-components'

import bgImg from './assets/img/background.jpg'

export const AppMainWrapper = styled.div`

`
